/**
 * @file: Leader.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 陪餐领导
 */
import request from '@/utils/request'

/**
 * 添加陪餐领导(ndj)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderInfoAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/info/add',
    method: 'post',
    data
  })
}

/**
 * 移除陪餐领导(ndj)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderInfoDelete(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/info/delete',
    method: 'post',
    data
  })
}

/**
 * 获取陪餐领导(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/info/get',
    method: 'post',
    data
  })
}

/**
 * 更新陪餐领导(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderInfoUpdate(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/info/update',
    method: 'post',
    data
  })
}

/**
 * 获取领导列表(ndj)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderListInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/list/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取领导分页列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcLeaderPageInfoGet(data) {
  return request({
    type: 'biz',
    url: 'pc/leader/page/info/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Leader.js